import { pickBy } from 'lodash';

export const deleteFalsyKeys = obj => pickBy(obj, Boolean);
